import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPromBusinessSearch, setPromBusinessSearch } from "../../../slices/filters";
export const usePromBusinessSearch = () => {
    const dispatch = useDispatch();
    const search = useSelector(getPromBusinessSearch);
    const update = useCallback((value) => {
        dispatch(setPromBusinessSearch(value));
    }, [dispatch]);
    return [search, update];
};
